export const checkForDuplicate = (updatedData, allData, idKey) => {
    const filteredRecord = allData.map((data) => data.original).filter(x => x[idKey] === updatedData[idKey]);

    return filteredRecord.length > 0 && updatedData.index !== filteredRecord[0].index;
};

export const checkForDuplicateRetailersForm = (retailerIdValue, indexValue, rows) => {
    const rawRecordsFiltered = rows.map(row => row.original).filter(row => row.retailerId === retailerIdValue);
    return rawRecordsFiltered.length > 0 && indexValue !== rawRecordsFiltered[0].index;
}
export const checkForDuplicateStoresForm = (storeIdValue, indexValue, rows) => {
    const rawRecordsFiltered = rows.map(row => row.original).filter(row => row.storeId === storeIdValue);
    return rawRecordsFiltered.length > 0 && indexValue !== rawRecordsFiltered[0].index;
}